import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useNavigateBlockerContext } from 'src/components/navigateBlockerProvider';

import type { IUseNavigateBlocker } from './useNavigateBlocker.interface';

export const useNavigateBlocker: IUseNavigateBlocker = (shouldBlock) => {
  const { setModalState, resetModalState } = useNavigateBlockerContext();

  const { reset, proceed, state } = useBlocker(
    ({ nextLocation, currentLocation }) =>
      nextLocation.pathname !== currentLocation.pathname &&
      (typeof shouldBlock === 'function'
        ? shouldBlock(nextLocation.pathname)
        : shouldBlock),
  );

  useEffect(() => {
    if (state === 'blocked') {
      setModalState({
        isOpen: true,
        proceedNavigation: proceed,
        resetNavigation: reset,
      });
    }

    return () => {
      resetModalState();
    };
  }, [proceed, reset, resetModalState, setModalState, state]);

  return {
    state,
  };
};
